export default "__VITE_ASSET__004ec81b__"